import React from 'react';
import MobileInvoiceDashboard from './MobileInvoiceDashboard';

// XRechnung Mobile Dashboard - verwendet die gemeinsame MobileInvoiceDashboard Komponente
const MobileXRechnungDashboard: React.FC = () => {
    // Verwende die gemeinsame MobileInvoiceDashboard mit invoiceType="xrechnung"
    return <MobileInvoiceDashboard invoiceType="xrechnung" />;
};

export default MobileXRechnungDashboard;
